module.exports = __webpack_public_path__ + "assets/icons/pulse-logo.aa8c73219018fd72a042de6dca4a88d3.svg";